import bodybuilder from 'bodybuilder'
import * as Form from '../../../components/form'
import * as Elasticsearch from '../../../elasticsearch'
import * as TopArticles from '../top-articles'
import * as Constants from './constants'

export const fetchTopPromotions =
  TopArticles.fetchTopArticlesFunction(Constants.FETCH_TOP_PROMOTIONS, true, Constants.NUM_TOP_PROMOTIONS)

export const fetchPromotionSends =
  TopArticles.fetchTopArticleSendFunction(Constants.FETCH_TOP_PROMOTION_SENDS, true)

export const fetchTopPromotionDetails = (community: string, topArticles: TopArticles.State) =>
  Elasticsearch.createEsSearch(Constants.FETCH_TOP_PROMOTION_DETAILS)(
    community,
    Elasticsearch.Indexes.TopClicks.Promotions,
    bodybuilder().size(100)
    .filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community),
      community)
    .query(
      'terms',
      Elasticsearch.DocumentFieldNames.Id,
      topArticles.data.map((a: TopArticles.TopArticle) => a.postId),
    )
    .build(),
  )

export const FormActions = Form.createActionsMap(Constants.TOP_PROMOTIONS_FILTER)



// WEBPACK FOOTER //
// ./src/pages/reports/promotions/actions.ts